export enum IconType {
	DOTS_HORIZONTAL_BLUE = 'ellipsis-solid-full.svg',
	USER_WITH_MAGNIFYING_GLASS_BLUE = 'user-magnifying-glass-solid-full.svg',
	BANK_ID = 'bank-id.svg',
}
